import React, { useContext as useContextCore } from 'react'

export type PivotViewerContextType = {
  container?: HTMLElement
}
const context = React.createContext<PivotViewerContextType>({} as PivotViewerContextType)

/** Props for the pivot viewer context provider. */
export type PivotViewerProviderProps = { children: React.ReactNode; container?: HTMLElement }

/** Provides the fullscreen portal target to pivot overlays. */
export const PivotViewerProvider = ({ children, container }: PivotViewerProviderProps) => (
  <context.Provider value={{ container }}>{children}</context.Provider>
)

/** Reads the pivot viewer context. */
export const usePivotViewerContext = () => useContextCore(context)
